<template lang="pug">
v-row(no-gutters)
  v-col.mr-3(v-if="logo" cols="2")
    v-img(:src="logo" contain max-height="85" max-width="85")
      template(v-slot:placeholder)
        v-row(class="fill-height ma-0" align="center" justify="center")
          v-progress-circular(indeterminate color="grey")
  v-col.text-left(v-if="!emptyAddress" cols="7")
    .text-xs.font-semibold.uppercase {{ address.name }}
    .text-xxs {{ getAddressInString(address) }}
    .text-xxs Tel: {{ address.phone }}
</template>

<script>
export default {
  props: {
    logo: {
      type: String,
      default: null
    },
    address: {
      type: Object,
      default: null
    },
  },
  computed: {
    emptyAddress () {
      if (Object.keys(this.address).length === 0) {
        return true
      } else if (Object.values(this.address).every(val => !val)) {
        return true
      }
      return false
    },
  },
  methods: {
    getAddressInString (addr) {
      let address = ''
      if (addr.address_1) {
        address += addr.address_1
      } if (addr.address_2) {
        address += `, ${addr.address_2}`
      } if (addr.postcode) {
        address += `, ${addr.postcode}`
      } if (addr.city) {
        address += `, ${addr.city}`
      } if (addr.state) {
        address += `, ${addr.state}`
      } if (addr.country) {
        address += `, ${addr.country}`
      }
      return address
    },
  },
}
</script>

<style lang="scss" scoped>
</style>